<template>
  <transition name="bottom" appear>
    <div class="keyboard" v-show="showKeyboard" :style="{ height: autoHeight ? 'auto' : `${height}px`, minHeight }" :class="{'desktop-visible': desktopVisible}">
        <slot></slot>
      </div>
  </transition>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/mixins';

  .keyboard {
    position: absolute;
    left: -30px;
    right: -30px;
    bottom: -30px;
    background: #E4E8ED;
    height: 58px;
    animation-duration: 0.4s;
    z-index: 500;

    @include desktop {
      display: none;
    }

    @media (max-width: #{$small-phone-width}) {
      display: none;
    }

    &.desktop-visible {
      @include desktop {
        display: block;
        border-bottom-left-radius: $moduleBorderRadius;
        border-bottom-left-radius: $moduleBorderRadius-portal;
        border-bottom-right-radius: $moduleBorderRadius;
        border-bottom-right-radius: $moduleBorderRadius-portal;
      }
    }
  }
</style>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'

  export default Vue.component('additional-keyboard', {
    props: {
      keep: {
        type: Boolean,
        default: false
      },
      desktopVisible: {
        type: Boolean,
        default: false
      },
      fixedHeight: {
        type: Number,
        default: null
      }
    },
    data () {
      return {
        showKeyboard: false,
        content: null,
        keyboardContentInterval: null,
        pollLimit: 0,
        inputInFocus: null
      }
    },
    created () {
      this.monitorInputFocus()
    },
    mounted () {
      setTimeout(() => { this.showKeyboard = true }, 500)
      this.getKeyboardContent()
    },
    computed: {
      ...mapState(['app']),

      isHidden () {
        return this.app.keyboardHeight === null || this.app.keyboardHeight === false
      },

      height () {
        const hasFixedHeight = this.fixedHeight && this.fixedHeight > 0
        if (hasFixedHeight && this.inputInFocus) {
          return this.fixedHeight
        }

        const contentHeight = this.content ? this.content.clientHeight : 0
        const ua = navigator.userAgent || ''
        const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
        const webkit = !!ua.match(/WebKit/i)
        const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
        const bottomBarHeight = iOSSafari ? 44 : 0
        const height = this.app.keyboardHeight + (contentHeight || 0) - bottomBarHeight
        return this.isHidden ? 0 : height
      },

      minHeight () {
        return this.isHidden ? '0px' : '58px'
      },

      autoHeight () {
        const desktopVisible = this.desktopVisible && this.app.deviceIsDesktop
        return this.keep || desktopVisible
      }
    },
    methods: {
      getKeyboardContent () {
        this.keyboardContentInterval = setInterval(() => {
          if (!this.content && this.pollLimit <= 10) {
            this.content = document.querySelector('.keyboard').firstChild
            this.pollLimit = this.pollLimit + +1
            return
          }
          window.clearInterval(this.keyboardContentInterval)
        }, 500)
      },
      onFocus () {
        this.inputInFocus = true
      },
      onBlur () {
        this.inputInFocus = false
      },
      monitorInputFocus () {
        const input = document.querySelector('input')

        if (input) {
          input.addEventListener('focus', this.onFocus, true)
          input.addEventListener('blur', this.onBlur, true)
        }
      }
    },
    beforeDestroy () {
      const input = document.querySelector('input')

      if (input) {
        input.removeEventListener('focus', this.onFocus, true)
        input.removeEventListener('blur', this.onBlur, true)
      }
      window.clearInterval(this.keyboardContentInterval)
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/AdditionalKeyboard.vue